import type {FC} from 'react';
import {Link} from '~library/atoms/Link';

import * as styles from './GalleryPromoTile.module.scss';

interface GalleryPromoTileProps {
  data: {
    src: string;
    href: string;
    text: string;
  };
  dataQaId?: string;
}

export const GalleryPromoTile: FC<GalleryPromoTileProps> = ({
  data,
  dataQaId = 'promo-tile-link',
}) => {
  const {src, href, text} = data;

  if (!src) return null;

  return (
    <Link
      href={href}
      as="transparent"
      className={styles.galleryPromoTile}
      data-qa-id={dataQaId}
      data-impression-tracking="true"
    >
      <img className={styles.galleryPromoTileImage} src={src} alt={`Promotional tile: ${text}`} />
    </Link>
  );
};
